import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { LocalStorageService } from 'ngx-webstorage';

@Component({
  standalone: true,
  selector: 'app-already-filed',
  templateUrl: './already-filed.html',
  styleUrls: ['./already-filed.css'],
  imports: [CommonModule]
})
export class AlreadyFiled {
  constructor(
    private router: Router,
    private storage: LocalStorageService) { }

  continueToClaimForm() {
    // Drop the used credential so the form doesn't re-prepopulate the read-only ID/PIN fields.
    this.storage.clear('authenticatedUser');
    this.storage.clear('utmTags');
    this.router.navigate(['/file-not-noticed']);
  }
}
